(function (window, document) {
  'use strict';

  var DEFAULT_CONFIG = {
    debug: false,
    collectorEndpoint: null,
    collectorWriteKey: null,
    destinations: {
      collector: true,
      ga4: false,
      meta: false,
      posthog: false,
    },
  };
  var SCHEMA_VERSION = '1.0';
  var ANALYTICS_SOURCE = 'colamy_custom';
  var EVENT_VERSION = '1.0';

  var config = Object.assign({}, DEFAULT_CONFIG, window.ColamyAnalyticsConfig || {});
  config.destinations = Object.assign(
    {},
    DEFAULT_CONFIG.destinations,
    (window.ColamyAnalyticsConfig && window.ColamyAnalyticsConfig.destinations) || {}
  );

  function destinationEnabled(destination) {
    return config.destinations && config.destinations[destination] === true;
  }

  function uuid() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }

    return 'evt-' + Date.now() + '-' + Math.random().toString(36).slice(2);
  }

  function safeGet(storage, key) {
    try {
      return storage && storage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function safeSet(storage, key, value) {
    try {
      if (storage) storage.setItem(key, value);
    } catch (error) {
      // Storage can be disabled in private browsing or strict privacy modes.
    }
  }

  function getOrCreate(storage, key) {
    var value = safeGet(storage, key);
    if (!value) {
      value = uuid();
      safeSet(storage, key, value);
    }
    return value;
  }

  function parseSearch(search) {
    var result = {};
    if (!search) return result;

    var query = search.charAt(0) === '?' ? search.slice(1) : search;
    query.split('&').forEach(function (part) {
      if (!part) return;

      var pair = part.split('=');
      var key = decodeURIComponent(pair[0] || '');
      if (!key) return;

      result[key] = decodeURIComponent((pair[1] || '').replace(/\+/g, ' '));
    });

    return result;
  }

  function getAttribution() {
    var params = parseSearch(window.location && window.location.search);
    var keys = [
      'utm_source',
      'utm_medium',
      'utm_campaign',
      'utm_id',
      'utm_term',
      'utm_content',
      'gclid',
      'fbclid',
      'ttclid',
    ];
    var attribution = {};

    keys.forEach(function (key) {
      if (params[key]) attribution[key] = params[key];
    });

    if (Object.keys(attribution).length > 0) {
      safeSet(window.localStorage, 'colamy_last_attribution', JSON.stringify(attribution));

      if (!safeGet(window.localStorage, 'colamy_first_attribution')) {
        safeSet(window.localStorage, 'colamy_first_attribution', JSON.stringify(attribution));
      }
    } else {
      try {
        attribution = JSON.parse(safeGet(window.localStorage, 'colamy_last_attribution') || '{}');
      } catch (error) {
        attribution = {};
      }
    }

    return attribution;
  }

  function readConsentState(source, methodName) {
    try {
      if (!source || typeof source[methodName] !== 'function') return 'unknown';
      return source[methodName]() ? 'granted' : 'denied';
    } catch (error) {
      return 'unknown';
    }
  }

  function getConsentState() {
    var customerPrivacy = window.Shopify && window.Shopify.customerPrivacy;

    if (!customerPrivacy) {
      return {
        analytics: 'unknown',
        marketing: 'unknown',
        source: 'default',
      };
    }

    return {
      analytics: readConsentState(customerPrivacy, 'analyticsProcessingAllowed'),
      marketing: readConsentState(customerPrivacy, 'marketingAllowed'),
      source: 'shopify_customer_privacy',
    };
  }

  function getPageContext() {
    var page = window.ColamyPage || {};

    return {
      type: page.type || '',
      template: page.template || '',
      url: window.location ? window.location.href : '',
      referrer: document.referrer || '',
    };
  }

  function queryKeys(search) {
    if (!search) return [];

    return search
      .replace(/^\?/, '')
      .split('&')
      .filter(Boolean)
      .map(function (part) {
        return decodeURIComponent((part.split('=')[0] || '').replace(/\+/g, ' '));
      })
      .filter(Boolean);
  }

  function canonicalDomain(hostname) {
    return (hostname || '').replace(/^www\./, '').toLowerCase();
  }

  function currentHostname() {
    var href = window.location && window.location.href;
    var match = href && String(href).match(/^[a-z][a-z0-9+.-]*:\/\/([^/?#]+)/i);
    return match ? match[1].toLowerCase() : '';
  }

  function parseHref(href) {
    var value = String(href || '');
    var hostname = currentHostname();
    var remainder = value;
    var protocolRelativeMatch = value.match(/^\/\/([^/?#]+)(.*)$/);
    var absoluteMatch = value.match(/^[a-z][a-z0-9+.-]*:\/\/([^/?#]+)(.*)$/i);

    if (absoluteMatch) {
      hostname = absoluteMatch[1].toLowerCase();
      remainder = absoluteMatch[2] || '/';
    } else if (protocolRelativeMatch) {
      hostname = protocolRelativeMatch[1].toLowerCase();
      remainder = protocolRelativeMatch[2] || '/';
    }

    var withoutHash = remainder.split('#')[0] || '/';
    var queryIndex = withoutHash.indexOf('?');
    var pathname = queryIndex >= 0 ? withoutHash.slice(0, queryIndex) : withoutHash;
    var search = queryIndex >= 0 ? withoutHash.slice(queryIndex) : '';

    if (pathname.charAt(0) !== '/') pathname = '/' + pathname;

    return {
      hostname: hostname,
      pathname: pathname || '/',
      search: search,
      params: parseSearch(search),
    };
  }

  function destinationForDomain(hostname) {
    var domain = canonicalDomain(hostname);

    if (domain === 'colamyhome.com') {
      return {
        destination_platform: 'official_site',
        link_type: 'official_site',
        link_domain: 'colamyhome.com',
      };
    }

    if (domain.indexOf('amazon.') !== -1) {
      return {
        destination_platform: 'amazon',
        link_type: 'marketplace',
        link_domain: 'amazon.com',
      };
    }

    if (domain.indexOf('walmart.') !== -1) {
      return {
        destination_platform: 'walmart',
        link_type: 'marketplace',
        link_domain: 'walmart.com',
      };
    }

    return {
      destination_platform: domain || '',
      link_type: domain ? 'external' : '',
      link_domain: domain,
    };
  }

  function destinationForMedium(utmMedium) {
    var medium = (utmMedium || '').toLowerCase();
    var socialPlatforms = {
      facebook: true,
      instagram: true,
      meta: true,
      pinterest: true,
      tiktok: true,
      youtube: true,
    };

    if (!medium) {
      return {
        destination_platform: '',
        link_type: '',
        link_domain: '',
      };
    }

    return {
      destination_platform: medium,
      link_type: socialPlatforms[medium] ? 'social' : 'campaign',
      link_domain: '',
    };
  }

  function enrichHrefProperties(properties) {
    var href = properties.href;
    if (!href) return properties;

    try {
      var parsed = parseHref(href);
      var destination = destinationForDomain(parsed.hostname);
      var utmMedium = parsed.params.utm_medium;

      properties.href = parsed.pathname || '/';
      properties.href_domain = parsed.hostname;
      properties.href_path = parsed.pathname || '/';
      properties.href_type = canonicalDomain(parsed.hostname) === 'colamyhome.com' ? 'internal' : 'external';
      properties.href_query_keys = queryKeys(parsed.search);

      if (utmMedium) properties.utm_medium = utmMedium;

      return Object.assign(properties, destination);
    } catch (error) {
      return properties;
    }
  }

  function normalizeProperties(eventName, properties, attribution) {
    var normalized = Object.assign({}, properties || {});
    var isClickEvent = eventName === 'click' || /_click$/.test(eventName);

    if (normalized.href) {
      return enrichHrefProperties(normalized);
    }

    if (isClickEvent && attribution && attribution.utm_medium) {
      normalized.utm_medium = attribution.utm_medium;
      return Object.assign(normalized, destinationForMedium(attribution.utm_medium));
    }

    return normalized;
  }

  function buildEvent(eventName, properties) {
    var attribution = getAttribution();

    return {
      schema_version: SCHEMA_VERSION,
      event_name: eventName,
      analytics_source: ANALYTICS_SOURCE,
      event_version: EVENT_VERSION,
      event_id: uuid(),
      timestamp: Date.now(),
      anonymous_id: getOrCreate(window.localStorage, 'colamy_anonymous_id'),
      session_id: getOrCreate(window.sessionStorage, 'colamy_session_id'),
      page: getPageContext(),
      attribution: attribution,
      consent_state: getConsentState(),
      write_key: config.collectorWriteKey || '',
      properties: normalizeProperties(eventName, properties, attribution),
    };
  }

  function destinationAllowed(destination, event) {
    if (!destinationEnabled(destination)) return false;

    var consent = event && event.consent_state;
    if (!consent) return true;
    if ((destination === 'ga4' || destination === 'posthog') && consent.analytics === 'denied') return false;
    if (destination === 'meta' && consent.marketing === 'denied') return false;

    return true;
  }

  function isPlainObject(value) {
    return Object.prototype.toString.call(value) === '[object Object]';
  }

  function toGA4Value(value) {
    if (Array.isArray(value)) {
      return value.map(function (item) {
        return item === null || item === undefined ? '' : String(item);
      }).filter(Boolean).join(',');
    }

    if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
      return value;
    }

    return String(value);
  }

  function addGA4Param(params, key, value) {
    if (!key || value === undefined || value === null) return;

    if (isPlainObject(value)) {
      Object.keys(value).forEach(function (childKey) {
        addGA4Param(params, key + '_' + childKey, value[childKey]);
      });
      return;
    }

    params[key] = toGA4Value(value);
  }

  function addGA4Params(params, values) {
    Object.keys(values || {}).forEach(function (key) {
      addGA4Param(params, key, values[key]);
    });
  }

  function ga4Params(event) {
    var params = {};

    addGA4Params(params, {
      analytics_source: event.analytics_source,
      schema_version: event.schema_version,
      event_version: event.event_version,
      event_id: event.event_id,
      anonymous_id: event.anonymous_id,
      session_id: event.session_id,
      timestamp: event.timestamp,
      page_type: event.page && event.page.type,
      page_template: event.page && event.page.template,
      page_url: event.page && event.page.url,
      page_referrer: event.page && event.page.referrer,
      consent_analytics: event.consent_state && event.consent_state.analytics,
      consent_marketing: event.consent_state && event.consent_state.marketing,
      consent_source: event.consent_state && event.consent_state.source,
    });
    addGA4Params(params, event.attribution);
    addGA4Params(params, event.properties);

    return params;
  }

  function sendToGA4(event) {
    if (!destinationAllowed('ga4', event)) return;
    if (typeof window.gtag !== 'function') return;

    window.gtag('event', event.event_name, ga4Params(event));
  }

  function sendToMeta(event) {
    if (!destinationAllowed('meta', event)) return;
    if (typeof window.fbq !== 'function') return;

    window.fbq(
      'trackCustom',
      event.event_name,
      Object.assign(
        {
          analytics_source: event.analytics_source,
          schema_version: event.schema_version,
          event_version: event.event_version,
          anonymous_id: event.anonymous_id,
          session_id: event.session_id,
          page_type: event.page.type,
        },
        event.attribution,
        event.properties
      ),
      { eventID: event.event_id }
    );
  }

  function sendToPostHog(event) {
    if (!destinationAllowed('posthog', event)) return;
    if (!window.posthog || typeof window.posthog.capture !== 'function') return;

    window.posthog.capture(
      event.event_name,
      Object.assign(
        {
          analytics_source: event.analytics_source,
          schema_version: event.schema_version,
          event_version: event.event_version,
          event_id: event.event_id,
          anonymous_id: event.anonymous_id,
          session_id: event.session_id,
          page_type: event.page.type,
          page_template: event.page.template,
          page_url: event.page.url,
        },
        event.attribution,
        event.properties
      )
    );
  }

  function sendToCollector(event) {
    if (!destinationEnabled('collector')) return;
    if (!config.collectorEndpoint) return;

    var body = JSON.stringify(event);

    if (window.navigator && typeof window.navigator.sendBeacon === 'function') {
      window.navigator.sendBeacon(config.collectorEndpoint, body);
      return;
    }

    if (typeof window.fetch === 'function') {
      window.fetch(config.collectorEndpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: body,
        keepalive: true,
      });
    }
  }

  function track(eventName, properties) {
    if (!eventName || typeof eventName !== 'string') return null;

    var event = buildEvent(eventName, properties);

    if (config.debug && window.console && typeof window.console.log === 'function') {
      window.console.log('[ColamyAnalytics]', event);
    }

    sendToGA4(event);
    sendToMeta(event);
    sendToPostHog(event);
    sendToCollector(event);

    return event;
  }

  window.ColamyAnalytics = {
    track: track,
    config: config,
    buildEvent: buildEvent,
  };
})(window, document);
